export const OP_TYPES = ["filter", "pivot", "normalize"] as const;
export type OpType = (typeof OP_TYPES)[number];

export const MODE_OPTIONS = ["blacklist"] as const;
export const RUNON_OPTIONS = ["esnode", "procnode"] as const;
export const SORT_BY_OPTIONS = ["value", "field"] as const;
export const SORT_ORDER_OPTIONS = [
    { value: "asc", label: "Ascending" },
    { value: "desc", label: "Descending" },
] as const;
export const DATA_TYPE_OPTIONS = [
    { value: "str", label: "String" },
    { value: "num", label: "Number" },
] as const;

export interface TransformEntry {
    key: string;
    value: string;
}

export interface FacetOp {
    type: OpType;
    mode?: string;
    runon?: string;
    "data-type"?: string;
    key?: string;
    blacklist?: string[];
    whitelist?: string[];
    col_key?: string;
    row_key?: string;
    sort_by?: string;
    sort_order?: string;
    row_transform?: TransformEntry[];
    col_transform?: TransformEntry[];
    col_blacklist?: string[];
    col_whitelist?: string[];
    row_blacklist?: string[];
    row_whitelist?: string[];
    include_total_cols?: boolean;
    include_total_rows?: boolean;
    /** Display-label order for matrix rows (list or label → rank map). */
    row_sort?: Record<string, number> | string[];
    /** Display-label order for matrix columns (list or label → rank map). */
    column_sort?: Record<string, number> | string[];
    /** Normalize op: data bank election label used as reference table. */
    reference_table?: string;
    /** Normalize op: key value → party name mappings (serialized as `transform`). */
    transform?: TransformEntry[];
    /** @deprecated Legacy single mapping — migrated to `transform` on parse. */
    reference_key?: string;
    /** @deprecated Legacy single key value — migrated to `transform` on parse. */
    value?: string;
}

export interface FacetFormModel {
    name: string;
    decimal_places: number;
    ds: Record<string, unknown>;
    ops: FacetOp[];
}

export const COMMON_FIELDS: (keyof FacetOp)[] = ["type", "mode", "runon", "data-type"];

export const FILTER_FIELDS: (keyof FacetOp)[] = ["key", "blacklist", "whitelist"];

export const PIVOT_NORMALIZE_FIELDS: (keyof FacetOp)[] = [
    "col_key",
    "row_key",
    "sort_by",
    "sort_order",
    "row_transform",
    "col_transform",
    "col_blacklist",
    "col_whitelist",
    "row_blacklist",
    "row_whitelist",
    "row_sort",
    "column_sort",
];

export const PIVOT_ONLY_FIELDS: (keyof FacetOp)[] = ["include_total_cols", "include_total_rows"];

/** Value written to `etl.ds.type` when persisting facet form JSON */
export const FACET_ETL_DS_TYPE_ESINDEX = "esindex";
